import { memo, useState } from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Breadcrumb from "@mui/material/Link";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useOrganizationStore } from "stores/OrganizationStore";

import { getOAuthURL } from "utility/google";

import ServiceConnectionInstructions from "components/ServiceConnectionInstructions";
import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const GoogleConnectSetupPage = memo(function GoogleConnectSetupPage() {
  const [organizationStore] = useOrganizationStore();
  const [readOnly, setReadOnly] = useState(false);

  //
  const oauthURL = getOAuthURL(organizationStore.uuid, readOnly);

  //
  return (
    <>
      <Breadcrumbs>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/sources"
        >
          Environment
        </Breadcrumb>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/sources"
        >
          Sources
        </Breadcrumb>
        <span />
      </Breadcrumbs>
      <ServiceConnectionInstructions label="Google Workspace Connection">
        <Stack spacing={2}>
          <Typography variant="body1" fontWeight="bold">
            How the ThreatKey for Google Workspace connection works:
          </Typography>
          <Typography variant="body1">
            Connect your ThreatKey account with Google Workspace in a just a few
            easy steps. Once connected, you can see all of your results on the
            Findings page.
          </Typography>
        </Stack>
      </ServiceConnectionInstructions>

      <ServiceConnectionStep disabled={false}>
        <FormControl>
          <FormLabel>Permissions</FormLabel>
          <RadioGroup
            value={readOnly}
            onChange={(e: any) => setReadOnly(e.target.value === "true")}
          >
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="Read-write permissions"
            />
            <FormControlLabel
              value={true}
              control={<Radio />}
              label="Read-only permissions (disables fixes)"
            />
          </RadioGroup>
        </FormControl>

        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            component="a"
            href={oauthURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Connect
          </Button>
        </Box>
      </ServiceConnectionStep>
    </>
  );
});

export default GoogleConnectSetupPage;
